import type { SmsSendOutcome } from '@/api/sms';

/**
 * SMS-emlékeztető őszinte-státusz (39-kör FE-3). A FE SOHA nem hazudik »elküldve«-t:
 * a gate-elt `POST /sms/send` kimenetét a valós BE-viselkedésre képezi.
 */
export type SmsReminderStatus = 'sent' | 'blocked' | 'dryRun' | 'failed';

/**
 * A `POST /sms/send` → `SmsSendOutcome` őszinte-státusz leképezése.
 *
 * Elsődleges: **strukturált `gateDecision`** (#735, #712-minta) — code-alapú detektálás a
 * törékeny error-substring/`logId`-heurisztika helyett. Ezzel a validation-fail (a gate
 * SEND-et döntött, de a küldés `!success` — pl. érvénytelen telefonszám) helyesen **`failed`**,
 * NEM »gate zárva« (a #734-review known-edge megszűnik).
 *
 * Legacy-fallback (ha az outcome-ban nincs `gateDecision` — régebbi BE / backward-compat):
 * a #731 pinnelt heurisztika (BLOCK = ÜRES `logId`; DRY_RUN = 'DRY-RUN' error-substring).
 */
export function smsOutcomeStatus(outcome: SmsSendOutcome): SmsReminderStatus {
  if (outcome.success) return 'sent';

  if (outcome.gateDecision) {
    if (outcome.gateDecision === 'BLOCK') return 'blocked';
    if (outcome.gateDecision === 'DRY_RUN') return 'dryRun';
    return 'failed'; // gateDecision === 'SEND' && !success → valódi provider/validation hiba
  }

  // Legacy-fallback (gateDecision nélküli outcome): #731 heurisztika.
  if (!outcome.logId || outcome.error?.includes('SMS_OUTBOUND_MODE')) return 'blocked';
  if (outcome.error?.includes('DRY-RUN')) return 'dryRun';
  return 'failed';
}
